import React, { useState, useEffect, useContext } from 'react';
import projectScopeImg from '../assets/images/projectScope.png';
import narrativeImg from '../assets/images/Narrative.png';
import aiGenRecImg from '../assets/images/aiGenRec.png';
import sgrStatusImg from '../assets/images/sgrstatus.jpg';
import genAIInsightsImg from '../assets/images/genAIInsights.png';
import riskImg from '../assets/images/riskIcon.png';
import Navbar from '../components/Navbar';
import { Container, Row, Col,Table } from "react-bootstrap";
import ReactMarkdown from 'react-markdown';
import { useNavigate,Link, useLocation  } from 'react-router-dom';
import { decryptString  } from '../utils/commonFunctions';
import Loader from '../components/Loader';
import axios from 'axios';
import html2pdf from 'html2pdf.js';
import { UserContext } from '../contexts/UserContext';
import FeedbackWidget from '../components/FeedbackWidget';
import { CONFIG} from '../config';


const columns = ["TMS ID | Team Name","Market | Market Unit | CSG","Overall","Client Satisfaction","Delivery","Financial","People/Resources","Information Security","Contract Management"];

function displayStatusColor(value){
  let parts = value.split('$');
  var status='';
  switch (parts[1]) {
    case "Green":
      status='project-green-circle';
      break;
    case "Amber":
      status='project-orange-circle';
      break;
    case 'Red':
      status='project-red-circle';
      break;
    case 'Grey':
      status='project-grey-circle';
      break;
    default:
      status='project-grey-circle';
  }
  return status
}

const ragMap = {
  Green: "🟢",
  Red: "🔴",
  Amber: "🟡",
  Grey: "🔘"
};

const getRagIcon = (value) => {
  try {
    // Handle null, undefined, "", NaN, objects, numbers
    if (!value || typeof value !== "string") return "NA";

    // Clean input
    const cleanValue = value.trim().toLowerCase();

    // Find key by case-insensitive match
    for (const key in ragMap) {
      if (key.toLowerCase() === cleanValue) {
        return ragMap[key];
      }
    }

    return "NA"; // default
  } catch (e) {
    return "NA";
  }
};

const toTitleCase = (str) => {
  if (!str || str.toUpperCase() === "NA") return str; // keep NA as-is
  return str
    .toLowerCase()
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

function getColorName(value) {
    if (!value || typeof value !== "string") {
    return "black"; // default if value is null/undefined/not string
  }
  switch (value.toLowerCase().trim()) {
    case "red":
      return "red";
    case "amber":
      return "orange";
    case "green":
      return "green"; 
    case "grey":
      return "orange";  
    default:
      return "black";
  }
}

function displayTitle(value){
  let parts = value.split('$');
  var status='';
  switch (parts[1]) {
    case "Green":
      status='Good';
      break;
    case "Amber":
      status='At Risk';
      break;
    case 'Red':
      status='Alert';
      break;
    case 'Grey':
      status='Not Reported';
      break;
    default:
      status='Not Reported';
  }
  return status
}

const Project = () => {
    const API = window.__ENV__?.REACT_APP_BACKEND_URL;
    console.log('api',API);
    const apiUrl = CONFIG.REACT_APP_BACKEND_URL+'/classifier_retrieval';
    const processUrl = CONFIG.REACT_APP_PROCESS;
    let impetusUrl = CONFIG.REACT_APP_IMPETUS_DASHBOARD;
    const sgrUrl = CONFIG.REACT_APP_SGR;
    const cirUrl = CONFIG.REACT_APP_CIR;
    const pactUrl = CONFIG.REACT_APP_PACT;
    //const apiUrl = 'https://divadevfalcon.azurewebsites.net/classifier_retrieval';
    const location = useLocation();
    const fullPath = location.pathname; 
    const encryptedId = fullPath.replace("/project/", "");
    const [filterColumn, setFilterColumn] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [clientName, setClientName] = useState("");
    const [clientNameUrl, setClientNameUrl] = useState("");
    const [contract, setContract] = useState("");
    const [contractUrl, setContractUrl] = useState("");
    const [selectedOptions, setSelectedOptions] = useState({});
    const [error, setError] = useState("");
    const [tmsName, setTmsName] = useState("");
    const [loading, setLoading] = useState(true);        
    const [allSelected, setAllSelected] = useState(false);
    const [projectDemographicsWeb, setprojectDemographicsWeb] = useState([]);       
    const [filteredData, setFilteredData] = useState([]);
    const [displayCol, setdisplayCol] = useState(["TMS ID | Team Name","Market | Market Unit | CSG"]);
    const [sortColumn, setSortColumn] = useState(''); // name or status
    const colorPriority = { "red-circle": 1, "orange-circle": 2, "green-circle": 3, "gray-circle": 4 };
    const navigate = useNavigate();
    const { projectsContext, setProjectsContext } = useContext(UserContext);
    const [showFeedback, setShowFeedback] = useState(true);
    const [firstReviewMonth, setFirstReviewMonth] = useState('NA');
    const [showAll, setShowAll] = useState(false);
    const MAX_VISIBLE = 4;

     const [acc1, setAcc1] = useState(false);
      const [acc2, setAcc2] = useState(false);
      const [acc3, setAcc3] = useState(false);
      const [acc4, setAcc4] = useState(false);
      const [acc5, setAcc5] = useState(false);
      const [isExpanded, setIsExpanded] = useState(true);
      const [metricType, setMetricType] = useState('workstream_Details_reported_Piroty');
      const [metricArray, setMetricArray] = useState([]);
      const [col2Array, setCol2Array] = useState([]);
      const [col3Array, setCol3Array] = useState([]);
      const [genAIExpanded, setGenAIExpanded] = useState({
    committedTab: false,
    scaledTab: false,
  });
      const [mmdDate, setMmdDate] = useState('');
      const [lastDate, setLastDate] = useState('');
      
    
      const expandAll = () => {
        setAcc1(true);
        setAcc2(true);
        setAcc3(true);
        setAcc4(true);
        setAcc5(true);
        setIsExpanded(false);
      };
    
      const collapseAll = () => {
        setAcc1(false);
        setAcc2(false);
        setAcc3(false);
        setAcc4(false);
        setAcc5(false);
        setIsExpanded(true);
      };

      const [expandedRows, setExpandedRows] = React.useState(new Set());

  // handlers
  const toggleRow = (index) => {
    setExpandedRows((prev) => {
      const updated = new Set(prev);
      if (updated.has(index)) updated.delete(index);
      else updated.add(index);
      return updated;
    });
  };

  const expandTableAll = () => setExpandedRows(new Set(allRows.map((_, i) => i)));
  const collapseTableAll = () => setExpandedRows(new Set());



  
    useEffect(() => {
      if(encryptedId){
        fetchData(encryptedId);
      }
      const handleClickOutside = (e) => {
        if (!e.target.closest(".filter-popup") && !e.target.closest(".filter-icon")) {
          setModalOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

    useEffect(() => {
      metricArray.map((row, idx) => {
        setCol2Array(Array.isArray(row[metricType]) ? row[metricType] : [row[metricType]]);
        console.log('col2Array',col2Array);
        setCol3Array(Array.isArray(row.workstream_Details_outliers) ? row.workstream_Details_outliers : [row.workstream_Details_outliers]);
      });
    }, [metricType]); 
    
  
    const fetchData = async (id) => {
      try{
      const postData=decryptString(id);
      console.log('postData json',postData);
      postData.query='project_demographics';
      postData.query_type='project_demographics_web';
      postData.startdate='';
      postData.enddate='';
      postData.e2eName='';
      postData.clientName='';
      postData.tmsId='';
      postData.custom_search='False';
      console.log('projectsContext',projectsContext);
      if(postData.clientUrl && postData.clientUrl!="undefined"){
            const clientData=decryptString(decodeURIComponent(postData.clientUrl));
            if(clientData){
              setClientName(clientData.clientName);
            }
            console.log('clientData',clientData);
            setClientNameUrl(encodeURIComponent(postData.clientUrl));
           }
      if(postData.contractUrl && postData.contractUrl!="undefined"){
            const contractData=decryptString(decodeURIComponent(postData.contractUrl));
            if(contractData){
              setContract(contractData.e2eName);
            }
            console.log('clientData',contractData);
            setContractUrl(encodeURIComponent(postData.contractUrl));
           }
      
      
      setTmsName(postData.tmsName);
      if(postData && postData.tmsName && projectsContext && projectsContext[postData.tmsName]) { 
        setprojectDemographicsWeb(projectsContext[postData.tmsName]);
        getMerticData(projectsContext[postData.tmsName]);  
       // setFilteredData(projectsContext[postData.contractID].contract_demographics_web.tmsList);     
      } else {
      await axios.post(apiUrl, postData)
      .then(response => {
        console.log('response',response);
        setprojectDemographicsWeb(response.data); 
        let first_review_month = "NA";
        if(response?.data?.project_demographics?.last_sunday) {
        setMmdDate('Data Source: MMD as on '+response.data.project_demographics.last_sunday+';');
        setLastDate(response.data.project_demographics.last_sunday);
        }
        if (
          response.data &&
          response.data.project_demographics &&
          Array.isArray(response.data.project_demographics.sgr) &&
          response.data.project_demographics.sgr.length > 0
        ) {
          const firstItem = response.data.project_demographics.sgr[0];
          first_review_month =
            firstItem && firstItem.review_month ? firstItem.review_month : "NA";
          setFirstReviewMonth(first_review_month);
        }       
        console.log('response',response);   
        getMerticData(response.data);         
        setProjectsContext(prev => ({
          ...prev,
          [postData.tmsName]: response.data
        }));       
      })
      .catch(error => {
        console.error('Error posting data:', error);
        setError("Failed to fetch data.");
      });
    }
    } catch (err) {
      setError("Failed to fetch data.");
    } finally {
      setLoading(false);
    } 
    }

    // const getMerticData =(response) =>{
    //   const hasMetricsReported = 'metrics_reported' in response.project_demographics.metrics;
    //   const hasMetricOutliers = 'metric_outliers' in response.project_demographics.metrics;
    
    // const metricsReportedPiroty = response.project_demographics?.metrics?.metrics_reported?.priority || [];
    // const metricsReportedNonPiroty = response.project_demographics?.metrics?.metrics_reported?.non_priority || [];
    // const metricOutliers = response.project_demographics?.metrics?.metric_outliers || [];
    
    // if (
    //   (!hasMetricsReported && !hasMetricOutliers) ||
    //   ((metricsReportedPiroty.length === 0)&& metricOutliers.length === 0)
    // ) {
    //   console.log('not inside len no workstrream');
    //   const metrics=[{workstream_name: "Not Reported",
    //       workstream_Details_reported_Piroty:[{'name':'No Metrics Reported','value':'No Metrics Reported','status':'No Metrics Reported'}],
    //       workstream_Details_reported_NonPiroty:[{'name':'No Metrics Reported','value':'No Metrics Reported','status':'No Metrics Reported'}],
    //       workstream_Details_outliers:[{'workstream_Details':'No Outliers Reported','workstream_values':'N/A'}]
    //      }]
    //      setMetricArray(metrics);
      
    // } else if (metricsReportedNonPiroty.length > 0 || metricsReportedPiroty.length > 0 || metricOutliers.length > 0) {
    //   console.log('inside len greater');

    //   const workstreamNameMRP = new Set(
    //     metricsReportedPiroty.map(item => item.workstream_name)
    //   );
    //   const workstreamNameMRNonP = new Set(
    //     metricsReportedNonPiroty.map(item => item.workstream_name)
    //   );
    //   const workstreamNameMO = new Set(
    //     metricOutliers.map(item => item.workstream_name)
    //   );

    //   const uniqueWorkstreamNames = Array.from(
    //     new Set([...workstreamNameMRP,...workstreamNameMRNonP, ...workstreamNameMO])
    //   ).sort();

    //   console.log('unique_workstream_name', uniqueWorkstreamNames);

    //   const compiledMetrics = uniqueWorkstreamNames.map(name => {
    //     let workstream_Details_reported_Piroty = {};
    //     let workstream_Details_reported_NonPiroty = {};
    //     let workstream_Details_outliers = {};

    //     const foundMetricReportedPiroty = metricsReportedPiroty.find(
    //       m => m.workstream_name === name
    //     );
    //     if (foundMetricReportedPiroty) {
    //       workstream_Details_reported_Piroty = foundMetricReportedPiroty.workstream_Details;
    //     }
    //     const valuesToRemove = ['NIS', "NaN", null];

    //     workstream_Details_reported_Piroty = Object.fromEntries(
    //       Object.entries(workstream_Details_reported_Piroty).filter(([key, val]) => !valuesToRemove.includes(val.value))
    //     );
    //     console.log('workstream_Details_reported');
    //     workstream_Details_reported_Piroty = Object.entries(workstream_Details_reported_Piroty).map(([key, val]) => ({
    //       name: key,
    //       value: val.value,
    //       status:val.status
    //     }));

    //     const foundMetricReportedNonPiroty = metricsReportedNonPiroty.find(
    //       m => m.workstream_name === name
    //     );
    //     if (foundMetricReportedNonPiroty) {
    //       workstream_Details_reported_NonPiroty = foundMetricReportedNonPiroty.workstream_Details;
    //     }
    //     workstream_Details_reported_NonPiroty = Object.fromEntries(
    //       Object.entries(workstream_Details_reported_NonPiroty).filter(([key, val]) => !valuesToRemove.includes(val.value))
    //     );
    //     console.log('workstream_Details_reported');
    //     workstream_Details_reported_NonPiroty = Object.entries(workstream_Details_reported_NonPiroty).map(([key, val]) => ({
    //       name: key,
    //       value: val.value,
    //       status:val.status
    //     }));
        
    //     console.log('workstream_Details_reported',workstream_Details_reported_NonPiroty,workstream_Details_reported_Piroty);
    //     console.log('metricOutliers',metricOutliers);
    //     const foundMetricOutlier = metricOutliers.filter(
    //       m => m.workstream_name === name
    //     );
    //     console.log('foundMetricOutlier',foundMetricOutlier);

    //     if (foundMetricOutlier) {
    //     workstream_Details_outliers = foundMetricOutlier.flatMap(item => {
    //       const workstream_name = item.workstream_name ?? '';
        
    //       const workstream_Details_key = typeof item.workstream_Details === 'string' ? item.workstream_Details.split(';') : [];
    //       const workstream_values_key = typeof item.workstream_values === 'string' ? item.workstream_values.split('|') : [];
        
    //       const maxLength = Math.max(workstream_Details_key.length, workstream_values_key.length);
        
    //       return Array.from({ length: maxLength }).map((_, index) => ({
    //         workstream_name,
    //         workstream_Details: workstream_Details_key[index] ?? '',
    //         workstream_values: workstream_values_key[index] ?? ''
    //       }));
    //     });
    //     }
    //     console.log('workstream_Details_outliers',workstream_Details_outliers);
    //     if(!name){
    //       name='Not Reported';
    //     }
    //     if(Array.isArray(workstream_Details_reported_Piroty) && workstream_Details_reported_Piroty.length === 0){
    //       workstream_Details_reported_Piroty=[{'name':'No Metrics Reported','value':'No Metrics Reported','status':'No Metrics Reported'}];
    //    }
    //     if(Array.isArray(workstream_Details_reported_NonPiroty) && workstream_Details_reported_NonPiroty.length === 0){
    //       workstream_Details_reported_NonPiroty=[{'name':'No Metrics Reported','value':'No Metrics Reported','status':'No Metrics Reported'}];
    //     }
    //     if(Array.isArray(workstream_Details_outliers) && workstream_Details_outliers.length === 0){
    //       workstream_Details_outliers=[{'workstream_Details':'No Outliers Reported','workstream_values':'N/A'}];
    //     }

    //     return {
    //       workstream_name: name,
    //       workstream_Details_reported_Piroty,
    //       workstream_Details_reported_NonPiroty,
    //       workstream_Details_outliers
    //     };
    //   });
    //    console.log('compiledMetrics',compiledMetrics)
    //   setMetricArray(compiledMetrics);
    // } 
    // }
const getMerticData = (response) => {

  const metrics =
    response.project_demographics?.metrics || {};

  const metricsReportedPiroty =
    metrics?.metrics_reported?.priority || [];

  const metricsReportedNonPiroty =
    metrics?.metrics_reported?.non_priority || [];

  const metricOutliers =
    metrics?.metric_outliers || [];

  const hasMetricsReported =
    metricsReportedPiroty.length > 0 || metricsReportedNonPiroty.length > 0;

  const hasMetricOutliers =
    metricOutliers.length > 0;

  // ---------------- NO DATA CASE ----------------
  if (!hasMetricsReported && !hasMetricOutliers) {
    setMetricArray([{
      workstream_name: "Not Reported",
      workstream_id: "",
      workstream_Details_reported_Piroty: [{
        name: 'No Metrics Reported',
        value: 'No Metrics Reported',
        status: 'No Metrics Reported'
      }],
      workstream_Details_reported_NonPiroty: [{
        name: 'No Metrics Reported',
        value: 'No Metrics Reported',
        status: 'No Metrics Reported'
      }],
      workstream_Details_outliers: [{
        workstream_Details: 'No Outliers Reported',
        workstream_values: 'N/A'
      }]
    }]);
    return;
  }

  // -------- BUILD WORKSTREAM → ID MAP (PRIORITY FIRST, THEN OUTLIERS) --------
  const workstreamIdMap = new Map();

  // 1️⃣ Priority has highest priority for ID
  metricsReportedPiroty.forEach(item => {
    if (item.workstream_name && item.workstream_id != null) {
      workstreamIdMap.set(item.workstream_name, item.workstream_id);
    }
  });

  // 2️⃣ Fill missing IDs from Outliers
  metricOutliers.forEach(item => {
    if (
      item.workstream_name &&
      item.workstream_id != null &&
      !workstreamIdMap.has(item.workstream_name)
    ) {
      workstreamIdMap.set(item.workstream_name, item.workstream_id);
    }
  });

  // ---------------- UNIQUE WORKSTREAM NAMES ----------------
  const uniqueWorkstreamNames = Array.from(
    new Set([
      ...metricsReportedPiroty.map(i => i.workstream_name),
      ...metricsReportedNonPiroty.map(i => i.workstream_name),
      ...metricOutliers.map(i => i.workstream_name)
    ])
  ).sort();

  // ---------------- BUILD FINAL METRICS ----------------
  const compiledMetrics = uniqueWorkstreamNames.map(name => {

    const rawId = workstreamIdMap.get(name);
    const workstream_id =
      rawId !== undefined && rawId !== null
        ? String(rawId).trim()
        : "";

    // ---------- PRIORITY ----------
    let workstream_Details_reported_Piroty = {};
    const foundMetricReportedPiroty =
      metricsReportedPiroty.find(m => m.workstream_name === name);

    if (foundMetricReportedPiroty) {
      workstream_Details_reported_Piroty =
        foundMetricReportedPiroty.workstream_Details;
    }

    const valuesToRemove = ['NIS', 'NaN', null];

    workstream_Details_reported_Piroty = Object.entries(workstream_Details_reported_Piroty)
      .filter(([_, val]) => !valuesToRemove.includes(val.value))
      .map(([key, val]) => ({
        name: key,
        value: val.value,
        status: val.status
      }));

    if (workstream_Details_reported_Piroty.length === 0) {
      workstream_Details_reported_Piroty = [{
        name: 'No Metrics Reported',
        value: 'No Metrics Reported',
        status: 'No Metrics Reported'
      }];
    }

    // ---------- NON PRIORITY ----------
    let workstream_Details_reported_NonPiroty = {};
    const foundMetricReportedNonPiroty =
      metricsReportedNonPiroty.find(m => m.workstream_name === name);

    if (foundMetricReportedNonPiroty) {
      workstream_Details_reported_NonPiroty =
        foundMetricReportedNonPiroty.workstream_Details;
    }

    workstream_Details_reported_NonPiroty = Object.entries(workstream_Details_reported_NonPiroty)
      .filter(([_, val]) => !valuesToRemove.includes(val.value))
      .map(([key, val]) => ({
        name: key,
        value: val.value,
        status: val.status
      }));

    if (workstream_Details_reported_NonPiroty.length === 0) {
      workstream_Details_reported_NonPiroty = [{
        name: 'No Metrics Reported',
        value: 'No Metrics Reported',
        status: 'No Metrics Reported'
      }];
    }

    // ---------- OUTLIERS ----------
    let workstream_Details_outliers = metricOutliers
      .filter(m => m.workstream_name === name)
      .flatMap(item => {

        const details = typeof item.workstream_Details === 'string'
          ? item.workstream_Details.split(';')
          : [];

        const values = typeof item.workstream_values === 'string'
          ? item.workstream_values.split('|')
          : [];

        const maxLen = Math.max(details.length, values.length);

        return Array.from({ length: maxLen }).map((_, i) => ({
          workstream_Details: details[i] ?? '',
          workstream_values: values[i] ?? ''
        }));
      });

    if (workstream_Details_outliers.length === 0) {
      workstream_Details_outliers = [{
        workstream_Details: 'No Outliers Reported',
        workstream_values: 'N/A'
      }];
    }

    // ---------- FINAL OBJECT ----------
    return {
      workstream_name: name || "Not Reported",
      workstream_id,
      workstream_Details_reported_Piroty,
      workstream_Details_reported_NonPiroty,
      workstream_Details_outliers
    };
  });

  setMetricArray(compiledMetrics);
};


    
    const handleSort = (column) => {
      setSortColumn(column);
  
      const sortedData = [...filteredData].sort((a, b) => {
        if (displayCol.includes(column)) {
          return a[column].localeCompare(b[column], undefined, { numeric: true, sensitivity: "base" });
        } else {
          return (colorPriority[a[column]] || 99) - (colorPriority[b[column]] || 99); // custom color sort
        }
      });
  
      console.log('sortedData',sortedData);
      setFilteredData(sortedData);
    };
  
    const handleFilterClick = (column) => {
      setFilterColumn(column);
      setSearchText("");
      setModalOpen(true);
    };
  
    const handleCheckboxChange = (value) => {
      setSelectedOptions((prev) => ({
        ...prev,
        [value]: !prev[value],
      }));
    };
  
    const handleSelectAll = () => {
      const options = getUniqueOptions();
      const newSelected = {};
      if (!allSelected) {
        options.forEach((option) => {
          newSelected[option] = true;
        });
      }
      setSelectedOptions(newSelected);
      setAllSelected(!allSelected);
    };
  
    const displayColumnsData = (col,value) =>{
      if(displayCol.includes(col))
        return value;
      else return '';
    }
    const handleRowClick = (project) => {
      console.log('client',project);
          
      // Navigate to another page
      navigate(`/contact`);
    };
  
    const handleApply = () => {
      if (!filterColumn) return;
  
      const selectedValues = Object.keys(selectedOptions).filter((key) => selectedOptions[key]);
  
      if (selectedValues.length === 0) {
        setFilteredData(projectDemographicsWeb.project_demographics.metrics); // No filter, show all
      } else {
        const newFilteredData = projectDemographicsWeb.project_demographics.metrics.filter((row) =>
          selectedValues.includes(row[filterColumn]?.toString())
        );
        setFilteredData(newFilteredData); //  Update filtered data
      }
      setModalOpen(false);
    };
  
    const getUniqueOptions = () => {
      if (!filterColumn) return [];
      const options = [...new Set(projectDemographicsWeb.project_demographics.metrics.map((item) => item[filterColumn]))];
      return options.filter((option) =>
        (option ?? "").toString().toLowerCase().includes(searchText.toLowerCase())
      );
    };

    const formatDate = (dateStr) => {
  if (!dateStr || typeof dateStr !== "string") return "NA";

  const date = new Date(dateStr);

  // Check invalid date
  if (isNaN(date.getTime())) return "NA";

  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};


        const handlePdfDownload = async () => {
            setLoading(true);
          //setIsExpanded(false);
            const container = document.createElement('div');
            const ids = ['clientHeader','projectHeader', 'about', 'projectLevelSummary','displayRAGStatus','flush-collapseOne','flush-collapseTwo','flush-collapseThree','flush-collapseFour','flush-collapseFive','pills-demographics-tab', 'pills-demographics','pills-metrics-tab', 'pills-metrics','pills-process_details-tab', 'pills-process_details'];
            const originalStyles = [];
            const originalStylesAccordian = [];
            const originalStyleRag = [];
            const originalStylesPills = [];
            const accordianpanel=['flush-collapseOne','flush-collapseTwo','flush-collapseThree','flush-collapseFour','flush-collapseFive'];
            const tabpanel=['pills-project_status','pills-demographics','pills-metrics','pills-process_details'];
            
            ids.forEach(id => {
              const element = document.getElementById(id);
              if (element) {
                if(id==='displayRAGStatus'){
                  originalStyleRag.push(element);
                  element.style.display= 'inline-flex';
                  element.style.justifyContent= 'flex-start';
                  element.style.alignItems= 'center';
                  element.style.gap= '1rem';
                  element.style.position = 'relative';
                  element.style.width = '500px';
                  element.style.height = '300px';
                 // element.firstChild.style.position='absolute';
                 // element.firstChild.style.top='absolute'
                }
                if(id==='pills-project_status-tab' || id==='pills-demographics-tab' || id==='pills-metrics-tab' || id==='pills-process_details-tab'){
                  originalStylesPills.push(element);
                  //element.classList.add('pdfHeading');
                  element.style.fontWeight = 'bold';
                  element.style.fontSize = '16px';
                }
                if(tabpanel.includes(id)){
                  console.log('inside');
                  //element.style.zoom='80%'                  
                }
                if(tabpanel.includes(id) && !element.classList.contains('active')){
                   originalStyles.push(element);
                   element.classList.add('show','active');
                }
                if(accordianpanel.includes(id)){
                  const newElement = document.createElement('div');
                  newElement.style.marginTop = '20px';
                  newElement.style.fontSize = '20px';
                  newElement.style.fontWeight = 'bold';
                  if(id==='flush-collapseOne')                    
                    newElement.innerText = 'Project Scope';               
                  else if(id==='flush-collapseTwo') 
                    newElement.innerText = 'Gen Ai Insights'; 
                  else if(id==='flush-collapseThree') 
                    newElement.innerText = 'Risk and Issues'; 
                  else if(id==='flush-collapseFour') 
                    newElement.innerText = 'Gen AI Recommendations'; 
                  else if(id==='flush-collapseFive') 
                    newElement.innerText = 'Narrative Status Comments'; 
                  container.appendChild(newElement);
                }
                if(accordianpanel.includes(id) && !element.classList.contains('show')){
                   originalStylesAccordian.push(element);
                //element.style.display = 'block';
                   element.classList.add('show');                  
                }
                //originalStyles.push({ element, display: element.style.display });
                //element.style.display = 'block';
                const clone = element.cloneNode(true);
                clone.style.position = 'relative';

                //clone.style.pageBreakInside = 'avoid';
                //clone.style.display = 'block';
                // 🧽 Remove elements by ID
                const toRemoveById = ['sortDiv','diva-userguide','displayExpandAll','metricsDiv'];
                toRemoveById.forEach(rid => {
                  const el = clone.querySelector(`#${rid}`);
                  if (el) el.remove();
                });
    
                // const hiddenTabs = clone.querySelectorAll('.bi bi-filter');
                // hiddenTabs.forEach(tab => tab.classList.add('show', 'active'));
    
        
                // // 🧽 Remove elements by class
                 const toRemoveByClass = clone.querySelectorAll('.bi-filter');
                 toRemoveByClass.forEach(el => el.remove());
                      
                clone.style.marginBottom = '20px';
                container.appendChild(clone);
              }
            });
        
            // const options = {
            //   margin: 0.5,
            //   filename: 'filtered-sections.pdf',
            //   image: { type: 'jpeg', quality: 0.98 },
            //   html2canvas: { scale: 2 },
            //   jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
            // }; 
            const newElement = document.createElement('div');
            newElement.style.marginTop = '20px';
            newElement.style.fontSize = '14px';
            newElement.style.fontWeight = 'bold';                 
            newElement.style.color = '#A100FF';                 
            newElement.style.textAlign = 'center';                 
            newElement.innerText = 'Content Generated by Gen AI, limiting accuracy in few cases. Please use at your own discretion.'; 
            container.appendChild(newElement);     
            const options = {
              margin: 0.5,
              filename: tmsName+'.pdf',
              image: { type: 'jpeg', quality: 0.98 },
              html2canvas: {
                scale: 2,
                useCORS: true,
                allowTaint: true,
              },
              jsPDF: {
                unit: 'in',
                format: 'a3', // landscape format
                orientation: 'landscape'
              },
              pagebreak:    { mode: ['avoid-all', 'css', 'legacy'] }
            };
            originalStyles.forEach(el  => {
              el.classList.remove('show','active');
            });
            originalStylesAccordian.forEach(el  => {
              el.classList.remove('show');
            });
            originalStylesPills.forEach(el  => {
              //el.classList.remove('pdfHeading');
              el.style.fontWeight = 400;
              el.style.fontSize = '16px';               
            });
            originalStyleRag.forEach(element  => {
                   element.style.position = 'unset';
                   element.style.width = '20%';
                   element.style.height = '300px';  
            });
           // setIsExpanded(true);
            html2pdf().set(options).from(container).save();
            setLoading(false);
          };

    const generateTableRows = () => {
      console.log('metricArray',metricArray)
        return metricArray.flatMap((row, idx) => {
          const col2Array = Array.isArray(row[metricType]) ? row[metricType] : [row[metricType]];
          const col3Array = Array.isArray(row["workstream_Details_outliers"]) ? row["workstream_Details_outliers"] : [row["workstream_Details_outliers"]];
          const maxRows = Math.max(col2Array.length, col3Array.length);
    
          return Array.from({ length: maxRows }, (_, i) => (
              <tr key={`${idx}-${i}`}>
                {i === 0 && (
                  <td rowSpan={maxRows} className="align-middle">
                    {row.workstream_name +' | ' + row.workstream_id}
                  </td>
                )}
                <td>{col2Array[i]?.name || ''}</td>
                <td className={col2Array[i]?.status || ''}>{col2Array[i]?.value || ''}</td>
                <td>{col3Array[i]?.workstream_Details || ''}</td>
                <td>
                  {/* <ul> */}
                    {col3Array[i]?.workstream_values.split(';').map((wv, index) => (
                       <p key={index}> {wv.trim()}</p>
                    ))}
                  {/* </ul> */}
                </td>
              </tr>
            ))
          });
      };

    if (error) { navigate(`/error`) }

    const tableRows = generateTableRows();


  return (
    <div className="container">
      {/* <div className='clientHeader'>
      <div className='contractimg '>
      <img src={divaimg} alt="diva" className="diva-img" /> |
      
      </div>
      <p className="displayHeaderText">Know Your Portfolio</p>
      <img src={userGuideimg} alt="User Guide" className="diva-userguide"  />
      <img src={releaseNotesimg} alt="Release Notes" className="diva-releasenotes" />
      </div> */}
      <Navbar />      
      <div className='projectHeader' id="projectHeader">
           <span className="projectHeaderTms"> {tmsName} </span>
      </div>
      <Container className="totalproject totalClient ">
      {/* Top Section with About & Export Button */}
      <Row className="align-items-center mb-3">
        <Col md={6} id="about">
          <h3>About</h3>
        </Col>
        <Col md={6} className="text-end">
        <div className="btn-group export-btn" role="group">
          <button type="button" className="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            Export
          </button>
          <ul className="dropdown-menu">
          <li><a className="dropdown-item" href="#" onClick={handlePdfDownload}>PDF</a></li>          
          </ul>
        </div>
        </Col>
      </Row>
      <div className='d-flex justify-content-between'>
      <div className='p-2'>
      { (contractUrl && contractUrl !== "undefined") && <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
       { (clientNameUrl && clientNameUrl !== "undefined") && <li className="breadcrumb-item">
          <Link className="breadcrumblink" to={`/client/${clientNameUrl}`}>{clientName}</Link>
        </li> }
        <li className="breadcrumb-item">
          <Link className="breadcrumblink" to={`/contact/${contractUrl}`}>{contract}</Link>
        </li>
        <li className="breadcrumb-item active" aria-current="page">
          {tmsName}
        </li>
      </ol>
    </nav> }
    </div>
    <div className='p-2'>
      {/* <span>Source: ATCI Delivery Portal, </span> <span>MMD Reporting Date: </span><span className='totalscr'>{projectDemographicsWeb?.project_demographics?.last_sunday}</span> */}
    </div>
    </div>
      {/* Gray Background Box */}
      <div className="p-3 bg-light rounded" id="projectLevelSummary">
        <h5 className='summaryTypeHeading'>Project level summary</h5>
        <table>
  <tbody className="container mt-4">
    <tr>
      <td className="col-6 col-md-4 width18 text-start">Client Name:</td>
      <td className="col-6 col-md-4 text-start">{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Client Name']}</td>       
      <td className="col-6 col-md-4 width18">Delivery Type:</td>
      <td className="col-6 col-md-4 text-start">{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Delivery Type']? projectDemographicsWeb.project_demographics['Delivery Type'] :''}</td>
    </tr>
    <tr>
    <td className="col-6 col-md-4 width18 text-start">Market | MU or IG | Industry:</td>
      <td className="col-6 col-md-4 text-start">{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Market | Market Unit | Client Group']? projectDemographicsWeb.project_demographics['Market | Market Unit | Client Group'] :''}</td>
      
    </tr>
  </tbody>
</table>

      </div>
      
      <ul className="nav nav-pills mb-3 displayTab" id="pills-tab" role="tablist">
      <li className="nav-item" role="presentation">
        <button className="nav-link active" id="pills-project_status-tab" data-bs-toggle="pill" data-bs-target="#pills-project_status" type="button" role="tab" aria-controls="pills-project_status" aria-selected="true">Project Status</button>
      </li>
      <li className="nav-item" role="presentation">
        <button className="nav-link" id="pills-demographics-tab" data-bs-toggle="pill" data-bs-target="#pills-demographics" type="button" role="tab" aria-controls="pills-demographics" aria-selected="false">Demographics</button>
      </li>
      <li className="nav-item" role="presentation">
        <button className="nav-link" id="pills-metrics-tab" data-bs-toggle="pill" data-bs-target="#pills-metrics" type="button" role="tab" aria-controls="pills-metrics" aria-selected="false">Metrics</button>
      </li>
      <li className="nav-item" role="presentation">
        <button className="nav-link" id="pills-process_details-tab" data-bs-toggle="pill" data-bs-target="#pills-process_details" type="button" role="tab" aria-controls="pills-process_details" aria-selected="false">Process Details</button>
      </li>
      </ul>
    <div className="tab-content" id="pills-tabContent">
      <div className="tab-pane fade show active" id="pills-project_status" role="tabpanel" aria-labelledby="pills-project_status-tab">
      <div className="d-inline-flex rounded-pill overflow-hidden border border-1 displayExpandAll" id="displayExpandAll">
      <button
        className={`btn ${!isExpanded ? 'text-white bg-purple' : 'bg-white'} rounded-0`}
        onClick={expandAll}
        style={{ borderRight: '1px solid #ccc' }}
      >
        Expand All
      </button>
      <button
        className={`btn ${isExpanded ? 'text-white bg-purple' : 'bg-white'} rounded-0`}
        onClick={collapseAll}
      >
        Collapse all
      </button>

    </div>
     <div className='projectStatusDiv'>
      <div className="accordion accordion-flush leftProjectStatus" id="accordionFlushExample">
      {/* <hr /> */}
            <div className="accordion-item">
                <h2 className="accordion-header">

                <button id="project_scope" className={`accordion-button ${!acc1 ? 'collapsed' : ''}`} onClick={() => setAcc1(!acc1)} type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                <img src={projectScopeImg} alt="Search" className='imgProject' />  Project Scope
                </button>
                </h2>
                <div id="flush-collapseOne" className={`accordion-collapse collapse ${acc1 ? 'show' : ''}`} data-bs-parent="#accordionFlushExample">
                <div className="accordion-body"><ReactMarkdown>{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['project scope'] ? projectDemographicsWeb.project_demographics['project scope']:''}</ReactMarkdown></div>
                </div>
            </div>
            {projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['AI Status check'] && projectDemographicsWeb.project_demographics['AI Status check']!='<Not Available>' && (<div className="accordion-item">
                <h2 className="accordion-header">
                <button className={`accordion-button ${!acc2 ? 'collapsed' : ''}`} onClick={() => setAcc2(!acc2)} type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                <img src={genAIInsightsImg} alt="Search" className='imgProject' />    Gen AI Insights 
                </button>
                </h2>
                <div id="flush-collapseTwo" className={`accordion-collapse collapse ${acc2 ? 'show' : ''}`} data-bs-parent="#accordionFlushExample">
                <div className="accordion-body"><ReactMarkdown>{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['AI Status check']?projectDemographicsWeb.project_demographics['AI Status check']:''}</ReactMarkdown></div>
                </div>
            </div> )}
            <div className="accordion-item">
                <h2 className="accordion-header">
                <button className={`accordion-button ${!acc3 ? 'collapsed' : ''}`} onClick={() => setAcc3(!acc3)} type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                <img src={riskImg} alt="Search" className='imgProject' />    Risk and Issues
                </button>
                </h2>
                <div id="flush-collapseThree" className={`accordion-collapse collapse ${acc3 ? 'show' : ''}`} data-bs-parent="#accordionFlushExample">
                <div className="accordion-body"><ReactMarkdown>{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Risk/Issues1']? projectDemographicsWeb.project_demographics['Risk/Issues1'] : ''}</ReactMarkdown></div>
                </div>
            </div>
            <div className="accordion-item">
                <h2 className="accordion-header">
                <button className={`accordion-button ${!acc4 ? 'collapsed' : ''}`} onClick={() => setAcc4(!acc4)} type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
                <img src={aiGenRecImg} alt="Search" className='imgProject' />    Gen AI Recommendations
                </button>
                </h2>
                <div id="flush-collapseFour" className={`accordion-collapse collapse ${acc4 ? 'show' : ''}`} data-bs-parent="#accordionFlushExample">
                <div className="accordion-body"><ReactMarkdown>{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['AI Recommendation']? projectDemographicsWeb.project_demographics['AI Recommendation'] :''}</ReactMarkdown></div>
                </div> 
            </div>
            <div className="accordion-item">
                <h2 className="accordion-header">
                <button className={`accordion-button ${!acc5 ? 'collapsed' : ''}`} onClick={() => setAcc5(!acc5)} type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
                <img src={narrativeImg} alt="Search" className='imgProject' />    Narrative Status Comments
                </button>
                </h2>
                <div id="flush-collapseFive" className={`accordion-collapse collapse ${acc5 ? 'show' : ''}`} data-bs-parent="#accordionFlushExample">
                <div className="accordion-body"><ReactMarkdown>{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['narratives summary']? projectDemographicsWeb.project_demographics['narratives summary']:''}</ReactMarkdown></div>
                </div>
            </div>
            <div className='fs-14 mt-2'><i>{mmdDate}</i></div>      
            </div>
            <div className="divider"></div>
            <div className="rightProjectStatus" id="displayRAGStatus">
              <div className='rightChildProjectStatus'>
                <h5> Current RAG Status</h5>
                <h6 className={displayStatusColor(projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Overall Status']? projectDemographicsWeb.project_demographics['Overall Status']: '')}
                    title={displayTitle(projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Overall Status']? projectDemographicsWeb.project_demographics['Overall Status']: '')}> Overall</h6>
                <h6 className={displayStatusColor(projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Delivery Status']? projectDemographicsWeb.project_demographics['Delivery Status']: '')}
                    title={displayTitle(projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Delivery Status']? projectDemographicsWeb.project_demographics['Delivery Status']: '')}>Delivery</h6>
                <h6 className={displayStatusColor(projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Client Satisfaction Status']? projectDemographicsWeb.project_demographics['Client Satisfaction Status']: '')}
                    title={displayTitle(projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Client Satisfaction Status']? projectDemographicsWeb.project_demographics['Client Satisfaction Status']: '')}>Client Satisfaction</h6>
                <h6 className={displayStatusColor(projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Financials Status']? projectDemographicsWeb.project_demographics['Financials Status']: '')}
                    title={displayTitle(projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Financials Status']? projectDemographicsWeb.project_demographics['Financials Status']: '')}>Financials</h6>
                <h6 className={displayStatusColor(projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['People / Resources Status']? projectDemographicsWeb.project_demographics['People / Resources Status']: '')}
                    title={displayTitle(projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['People / Resources Status']? projectDemographicsWeb.project_demographics['People / Resources Status']: '')}>People / Resources</h6>
                <h6 className={displayStatusColor(projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Infosec Status']? projectDemographicsWeb.project_demographics['Infosec Status']: '')}
                    title={displayTitle(projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Infosec Status']? projectDemographicsWeb.project_demographics['Infosec Status']: '')}>Information Security</h6>
                <h6 className={displayStatusColor(projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Contract Management Status']? projectDemographicsWeb.project_demographics['Contract Management Status']: '')}
                    title={displayTitle(projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Contract Management Status']? projectDemographicsWeb.project_demographics['Contract Management Status']: '')}>Contract Management</h6>
            </div>
            </div>
        </div>
        </div>
      <div className="tab-pane fade" id="pills-demographics" role="tabpanel" aria-labelledby="pills-demographics-tab">
      <table className="table table-striped smart-table DemographicsTable">
        <tbody>
          <tr>
            <td>Contract ID | End to End Name (ID)</td>
            <td>{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Contract ID | End to End Name (ID)'] ? projectDemographicsWeb.project_demographics['Contract ID | End to End Name (ID)']:''}</td>
          </tr>
          <tr>
            <td>Account Group | Delivery Group | Delivery Unit</td>
            <td>{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Account Group | Delivery Group | Delivery Unit'] ? projectDemographicsWeb.project_demographics['Account Group | Delivery Group | Delivery Unit'] :''}</td>
          </tr>
          <tr>
            <td>Company | Responsible Delivery Entity</td>
            <td>{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Company | Responsible Delivery Entity'] ? projectDemographicsWeb.project_demographics['Company | Responsible Delivery Entity']:''}</td>
          </tr>
          <tr>
            <td>Account Group | Delivery Group | Delivery Unit</td>
            <td>{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Account Group | Delivery Group | Delivery Unit']? projectDemographicsWeb.project_demographics['Account Group | Delivery Group | Delivery Unit'] :'' }</td>
          </tr>
          <tr>
            <td>Overall Delivery Lead</td>
            <td>{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Overall Delivery Lead'] ? projectDemographicsWeb.project_demographics['Overall Delivery Lead'] :''}</td>
          </tr>
          <tr>
            <td>Pricing</td>
            <td>{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Pricing'] ? projectDemographicsWeb.project_demographics['Pricing'] :''}</td>
          </tr>
          <tr>
            <td>Service Group | Interaction Style</td>
            <td>{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Service Group | Interaction Style']? projectDemographicsWeb.project_demographics['Service Group | Interaction Style'] :''}</td>
          </tr>
          <tr>
            <td>Delivery MD | Delivery Lead | Project Manager</td>
            <td>{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Delivery MD | Delivery Lead | Project Manager']? projectDemographicsWeb.project_demographics['Delivery MD | Delivery Lead | Project Manager'] :''}</td>
          </tr>
          <tr>
            <td>E2E Led Reporting Portfolio | Dominant Account Group</td>
            <td>{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['E2E Led Reporting Portfolio | Dominant Account Group']?projectDemographicsWeb.project_demographics['E2E Led Reporting Portfolio | Dominant Account Group']:''}</td>
          </tr>
          <tr>
            <td>Primary Technology</td>
            <td>{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Primary Technology']? projectDemographicsWeb.project_demographics['Primary Technology'] :''}</td>
          </tr>
          <tr>
            <td>Total peak FTE</td>
            <td>{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Total peak FTE']?projectDemographicsWeb.project_demographics['Total peak FTE'] : ''}</td>
          </tr>
          <tr>
            <td>Gen AI related productivity in contract (Y/N)</td>
            <td>{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Gen AI related productivity in contract (Y/N)']? projectDemographicsWeb.project_demographics['Gen AI related productivity in contract (Y/N)'] :''}</td>
          </tr>
          <tr>
            <td>Gen AI Implementation Status</td>
            <td>{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Gen AI Implementation Status']?projectDemographicsWeb.project_demographics['Gen AI Implementation Status']:''}</td>
          </tr>
          <tr>
            <td>Start Date & End Date</td>
            <td>{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['Start Date  & End Date']? projectDemographicsWeb.project_demographics['Start Date  & End Date'] : ''}</td>
          </tr>
          <tr>
            <td>E2E Creation Date</td>
            <td>{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['E2E Creation Date']? projectDemographicsWeb.project_demographics['E2E Creation Date'] : ''}</td>
          </tr>
        </tbody>
      </table>
      <div className='fs-14 mt-2'><i>{mmdDate}</i></div>             
      </div>
      <div className="tab-pane fade" id="pills-metrics" role="tabpanel" aria-labelledby="pills-metrics-tab">
             <Container className="mt-4 metricsTab">
                 
                  <div className="d-inline-flex rounded-pill overflow-hidden border border-1 metricsDiv" id="metricsDiv">
                  <button
                    className={`btn ${metricType !=='workstream_Details_reported_NonPiroty' ? 'text-white bg-purple' : 'text-dark bg-white'} rounded-0`}
                    onClick={() => setMetricType('workstream_Details_reported_Piroty')}
                    style={{ borderRight: '1px solid #ccc' }}
                  >
                    Key Metrics
                  </button>
                  <button
                    className={`btn ${metricType==='workstream_Details_reported_NonPiroty' ? 'text-white bg-purple' : 'text-dark bg-white'} rounded-0`}
                    onClick={() => setMetricType('workstream_Details_reported_NonPiroty')}
                  >
                    All Metrics
                  </button>
            
                </div>
                  <table className="table table-bordered text-center align-middle">
                    <thead>
                      <tr>
                      <th rowSpan={2} style={{ verticalAlign: 'middle', textAlign: 'center' }}>Workstream Name | ID</th>
                        <th colSpan={2} className="text-center">Key Metrics (MMD)</th>
                        <th colSpan={2} className="text-center">Metrics Outlier (Beacon)</th>          
                      </tr>
                      <tr>
                        <th className="text-center">Metric Name</th>
                        <th className="text-center">Value</th>
                        <th className="text-center">Outlier Check</th>
                        <th className="text-center">Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      { tableRows }
                    </tbody>
                  </table>
                  <div>
                    <p>{projectDemographicsWeb?.project_demographics?.metrics?.mmd_reported && <span> {mmdDate} </span>}{projectDemographicsWeb?.project_demographics?.metrics?.beacon_date && <span>Beacon Report as on {formatDate(projectDemographicsWeb?.project_demographics?.metrics?.beacon_date)};</span>} </p>
                    {projectDemographicsWeb?.project_demographics?.metrics?.beacon_date && <p>For any questions regarding the Beacon Report, please contact your respective Dex POC</p> }
                  </div>
                </Container>                
      </div>
      <div className="tab-pane fade" id="pills-process_details" role="tabpanel" aria-labelledby="pills-process_details-tab">
      <table className="table table-bordered smart-table projectDetailsTable">
        <thead>
          <tr>
          <td>Process</td>
          <td>Details</td>
          </tr>
        </thead>

        <tbody>
        <tr>
            <td>Non Compliance Details</td>
            <td>{projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['DL score'] ? 'Total Non Compliances: '+projectDemographicsWeb.project_demographics['DL score']:0}
            {projectDemographicsWeb && projectDemographicsWeb.project_demographics && projectDemographicsWeb.project_demographics['NC line items'] ? 
             <ul>                           
                {projectDemographicsWeb.project_demographics['NC line items'].map((nc, index) => (
                  <li key={index}> {nc}</li>
               ))}
               </ul> :''
            }
            <div className="d-flex justify-content-between align-items-center mt-2">
  <div>
     <span className='fs-14 mt-2'>Data Source: DL Scorecard PBI Report as on {lastDate}</span>
  </div>
  <div>
           
  </div>
</div>
            </td></tr>
          <tr>
            <td>Gen AI Implementation Status</td>
            <td>
    {(() => {
  // Validate projectDemographicsWeb existence
  if (
    !projectDemographicsWeb ||
    !projectDemographicsWeb.project_demographics
  ) {
    return <p className="text-center mt-3 text-danger">Project data not available.</p>;
  }
  
  // Mapping backend keys → readable table column names
const columnLabelMap = {
  effortsavingsgenaiplannedperc: "Gen AI Effort Savings (%)",
  genaiappliedservicegroup: "Service Group",
  pattern: "Pattern",
  ragStatus: "Gen AI RAG",
  genaiSavings: "Gen AI Saving",
  genaiproductivity: "Planned Gen AI Productivity ($)",
  genairealizedproductivity: "Realized Gen AI Productivity ($)",
  whereIsTheSavingsBeingReflected: "Savings Reflection",
};

// Handle empty/null/Nan values
const sanitize = (val) => {
  if (val === null || val === undefined) return "--";
  if (typeof val === "string" && val.toLowerCase() === "nan") return "--";
  return val;
};

const sanitizeCommitted = (val) => {
  if (val === null || val === undefined) return " NO| NO";
  if (typeof val === "string" && val.toLowerCase() === "nan") return " NO| NO";
  return val;
};

const mergeByKey = (arr1, arr2, key) => {
  const map = {};

  for (const obj of arr1) {
    map[obj[key]] = { ...obj };
  }

  for (const obj of arr2) {
    if (map[obj[key]]) {
      map[obj[key]] = { ...map[obj[key]], ...obj };
    } else {
      map[obj[key]] = { ...obj };
    }
  }

  return Object.values(map);
}

const renderCombinedTable = () => {
  const datajson = projectDemographicsWeb.project_demographics;

  const committedRows = Array.isArray(datajson.committed) ? datajson.committed : [];
  const scaledRows = Array.isArray(datajson.scaled) ? datajson.scaled : [];

  // add a `type` field to each row
  const merged = mergeByKey(committedRows,scaledRows,'genaiappliedservicegroup')
  console.log('merged',merged);

  if (!merged.length) return <div className="text-muted">No Data Available</div>;

  // final combined columns
  const columns = [
    "genaiappliedservicegroup",
    "ragStatus",
    "pattern",
    "effortsavingsgenaiplannedperc",
    "effortsavingsgenaiplannedperc",
    "genaiproductivity",
    "genairealizedproductivity",
    "whereIsTheSavingsBeingReflected"
  ];

  return (
    <Table bordered hover striped size="sm" responsive>
      <thead>
        <tr className='bg-white'><th></th><th colSpan='4'>Committed</th><th className='bg-white' colSpan='3'>Scaled</th></tr>
       
      </thead>

      <tbody>
         <tr>
            <th key='service1' className="text-center fw-medium">Service Group</th>
            <th key='rag1' className="text-center fw-medium">Gen AI RAG </th>
            <th key='Pattern1' className="text-center fw-medium">Pattern</th>
            <th key='Effort1' className="text-center fw-medium">Gen AI Effort Savings (%) </th>
            <th key='Savings1' className="text-center fw-medium">Overall Productivity(%)</th>
            <th key='Planned' className="text-center fw-medium">Planned Gen AI Productivity ($) </th>
            <th key='Realized' className="text-center fw-medium"> Realized Gen AI Productivity ($)</th>
            <th key='Savings' className="text-center fw-medium">Savings Reflection </th>
        </tr>
        {merged.map((row, i) => (
          <tr key={i}>
              <td className="text-center" key={`service1${i}`}> {sanitize(row['genaiappliedservicegroup']) || ""}</td>
              <td className="text-center" key={`service1${i}`}> {getRagIcon(row['ragStatus']) || ""}</td>
              <td className="text-center" key={`service1${i}`}> {sanitize(row['pattern']) || ""}</td>
              <td className="text-center" key={`service1${i}`}> {sanitize(row['genaiappliedservicegroup']=='SI'?row['effortsavingsgenaiplannedperc']:'--') || "--"}</td>
              <td className="text-center" key={`service1${i}`}> {sanitize(row['genaiappliedservicegroup']!='SI'?row['effortsavingsgenaiplannedperc']:'--') || "--"}</td>
              <td className="text-center" key={`service1${i}`}> {sanitize(row['genaiproductivity']) || ""}</td>
              <td className="text-center" key={`service1${i}`}> {sanitize(row['genairealizedproductivity']) || ""}</td>
              <td className="text-center" key={`service1${i}`}> {sanitize(row['whereIsTheSavingsBeingReflected']) || ""}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};


  return (
    <div className="container mt-4">
      {/* Expand / Collapse ALL */}
      <div className="d-flex justify-content-between align-items-center w-100">

  <div className="mb-2">
  <span> Committed | Scaled : {sanitizeCommitted(projectDemographicsWeb.project_demographics["Committed | Scaled"]) || 'NA'}</span>
    <br/>
    <span>   {renderCombinedTable()} </span>
  </div>
</div>


                 <div className="d-flex justify-content-between align-items-center mt-2">
  <div>
      Data Source: <a target="_blank" href="https://atcidelivery.accenture.com/Central/special-focus/gen-aitracking/genAITrackingLanding">Gen AI Tracking Dashboard</a>
  </div>
  <div>
  </div>
</div>
    </div>
  )


})()} </td>
            {/* <td><ReactMarkdown>{Project_GenAi_adaptive_text(projectDemographicsWeb.project_demographics)}</ReactMarkdown> */}
            {/* </td> */}
          </tr>
          <tr>
            <td>CIR</td>
            <td>{projectDemographicsWeb && projectDemographicsWeb.cir_summary? projectDemographicsWeb.cir_summary: ''}<br/><br/>
<div className="d-flex justify-content-between align-items-center mt-2">
  <div>
    Data Source: <a target="_blank" href={cirUrl}>CIR Dashboard</a>
  </div>
  <div>
  </div>
</div>
            </td>
          </tr>
          <tr>
            <td>PACT</td>
            <td>{projectDemographicsWeb && projectDemographicsWeb.pact_summary ? projectDemographicsWeb.pact_summary :''}<br/><br/>
            <div className="d-flex justify-content-between align-items-center mt-2">
  <div>
    Data Source: <a target="_blank" href={pactUrl}>PACT Dashboard</a>
  </div>
  <div>
  </div>
</div></td>
          </tr>
          <tr>
            <td>Process Review</td>
            <td>
          {projectDemographicsWeb?.project_demographics?.process_review?.review_status ?  (
  <ul>
    <li>
      Review Status:{" "}
      <span>
        {projectDemographicsWeb.project_demographics.process_review
          ?.review_status || "NA"}
      </span>
    </li>

<table>
  <thead>
    <tr>
      <th>Assessment Type</th>
      <th>Process Maturity Index (PMI) Score</th>
      <th>Completed On</th>
    </tr>
  </thead>
  <tbody>
    {projectDemographicsWeb.project_demographics.process_review?.assessments
      ?.length > 0 ? (
      projectDemographicsWeb.project_demographics.process_review.assessments.map(
        (assess, index) => (
          <tr key={index}>
            <td className="text-center">{assess.Type || "Not Reported"}</td>
            <td className="text-center" style={{
              color: getColorName(
                assess?.PMI_RAG
              ),
            }}>{assess.Type === 'MD Approval' ? (assess.PMI || "NA") : (assess.PMI ||"Not Reported")}</td>
            <td className="text-center">{assess["Completion Date"] || "Not Reported"}</td>
          </tr>
        )
      )
    ) : (
      <tr>
        <td className="text-center" colSpan={3}>No data available for the project</td>
      </tr>
    )}
  </tbody>
</table>
  </ul>
) : (
  <div>No data available for the project</div>
)}


           <div className="">
  {projectDemographicsWeb?.project_demographics?.process_review?.review_month && 
   <div className="d-flex justify-content-between align-items-center mt-2">
  <div>
    Data Source:{" "}
    <a target="_blank" href={processUrl}>Process Review Dashboard</a> as on <span>
      {projectDemographicsWeb?.project_demographics?.last_sunday
        ? projectDemographicsWeb.project_demographics.last_sunday
        : "NA"} </span>   
  </div>
  <div>
     </div>
</div>  }
  {/* <div>
    Data as on :{" "}
    <span>
      {projectDemographicsWeb?.project_demographics?.last_sunday
        ? projectDemographicsWeb.project_demographics.last_sunday
        : "NA"}
    </span>
  </div> */}
</div>

            </td>
          </tr>
          <tr>
            <td>Impetus</td>
            <td>
{projectDemographicsWeb?.project_demographics?.impetus?.impetusStatus ? (
  (() => {
    const impetus = projectDemographicsWeb.project_demographics.impetus;
    const status = impetus.impetusStatus?.trim() || "NA";
    const remarks = impetus.impetusRemarks || "NA";
    if(impetus.e2eOrTmsid)
    impetusUrl=CONFIG.REACT_APP_IMPETUS+'/'+impetus.e2eOrTmsid;
    else 
      impetusUrl=CONFIG.REACT_APP_IMPETUS_DASHBOARD

    console.log('impetusUrl',impetusUrl);
    // Case 1: On-Hold / Lean Support / No Support
    if (["On-Hold", "Lean Support", "No Support"].includes(status)) {
      return (
        <ul>
          <li>
            <span>Impetus Status:</span> {status}
          </li>
          <li>
            <span>Remarks:</span> {impetus.impetusRemarks?.trim() || "NA"}
          </li>
        </ul>
      );
    }

    // Case 2: New / Draft / Assigned
    if (["New", "Draft", "Assigned"].includes(status)) {
      return (
        <ul>
          <li>
            <span>Impetus Status:</span> Not Started
          </li>
        </ul>
      );
    }

    // Case 3: Default (old logic)
    return (
      <ul>
        {/* Status */}
        <li>
          <span >Impetus Status:{" "}</span>
          <span>
            {status === "In Progress" || status === "Ready"
              ? "In Progress"
              : status === "Handed Over"
              ? "Handed Over"
              : status || "N/A"}
          </span>
        </li>

        {/* Last Date */}
        <li>
          {status === "Handed Over"
            ? "Impetus Handover Date : "
            : "Impetus Start Date : "}
          <span>{impetus.impetusConductedLastDate || "NA"}</span>
        </li>

        {/* RAG Comparison */}
        <li>
              Impetus RAG:{" "}
              <span
                style={{
                  color: getColorName(impetus?.impetusRagStatus),
                }}
              >
                {toTitleCase(
                  impetus?.impetusRagStatus === "grey"
                    ? "Not Reported"
                    : impetus?.impetusRagStatus || "Not Reported"
                )}
              </span>
                         &nbsp; | MMD RAG:{" "}
              <span
                style={{
                  color: getColorName(impetus?.myWizardRag),
                }}
              >
                {toTitleCase(
                  impetus?.myWizardRag === "grey"
                    ? "Not Reported"
                    : impetus?.myWizardRag || "NA"
                )}
              </span>            
        </li>
      </ul>
    );
  })()
) : (
  <div>No data available for the project</div>
)}

      <div className="d-flex justify-content-between align-items-center mt-2">
  <div>
    Data Source: <a target="_blank" href={impetusUrl}>Impetus Dashboard</a>
  </div>
  <div>
  </div>
</div>
            </td>
          </tr>
<tr>
  <td>Stage Gate Review</td>
  <td colSpan="5">
    {(() => {
  // Validate projectDemographicsWeb existence
  if (
    !projectDemographicsWeb ||
    !projectDemographicsWeb.project_demographics
  ) {
    return <p className="text-center mt-3 text-danger">Project data not available.</p>;
  }

  const sgrList = Array.isArray(
    projectDemographicsWeb.project_demographics.sgr
  )
    ? projectDemographicsWeb.project_demographics.sgr
    : [];
  console.log('sgr',sgrList);

  // Safely map the list into rows
  const allRows = sgrList.map((sgr) => {
    const workstream = sgr?.workstream_name?.trim() || "NA";
    const workstreamID = sgr?.workstream_id || " ";
    const phase = sgr?.phase?.trim() || "NA";
    const review_status = sgr?.review_status?.trim() || "NA";
    const review_month = sgr?.review_month?.trim() || "NA";

    const assessments =
      Array.isArray(sgr?.assessments) && sgr.assessments.length > 0
        ? sgr.assessments.map((a) => ({
            Type: a?.Type?.trim() || "Not Reported",
            maturity_level: a?.maturity_level?.trim() || "Not Reported",
            "Completion Date": a?.["Completion Date"]?.trim() || "Not Reported",
          }))
        : [
            {
              Type: "Not Reported",
              maturity_level: "Not Reported",
              "Completion Date": "Not Reported",
            },
          ];

    return { workstream,workstreamID, review_month, phase, review_status, assessments };
  });

  // Safety log (optional for debugging)
  console.log("expandedRows:", expandedRows, "Total Rows:", allRows.length);

  // Expand/Collapse button states
  const isAllExpanded = expandedRows.size === allRows.length && allRows.length > 0;
  const isAnyExpanded = expandedRows.size > 0;

  return (
    <>
      {/* Expand/Collapse Buttons */}
      

      {/* Parent Table */}
      {allRows.length > 0 ? (
        <>
        <div className="mb-2 d-flex justify-content-end">
        <button
          className={`btn btn-sm me-2 ${
            isAllExpanded ? "btn-secondary" : "btn-outline-primary"
          }`}
          onClick={() => setExpandedRows(new Set(allRows.map((_, i) => i)))}
          disabled={isAllExpanded || allRows.length === 0}
        >
          Expand All
        </button>

        <button
          className={`btn btn-sm ${
            !isAnyExpanded ? "btn-secondary" : "btn-outline-primary"
          }`}
          onClick={() => setExpandedRows(new Set())}
          disabled={!isAnyExpanded}
        >
          Collapse All
        </button>
      </div>
        <table className="table table-bordered align-middle">
          <thead>
            <tr>
              <th>Workstream Name | ID </th>
              <th>Phase</th>
              <th>Review Status</th>
            </tr>
          </thead>
          <tbody>
            {allRows.map((row, idx) => (
              <React.Fragment key={idx}>
                {/* Parent Row */}
                <tr
                  className={`cursor-pointer ${
                    expandedRows.has(idx) ? "table-active" : ""
                  }`}
                  onClick={() => toggleRow(idx)}
                >
                  <td>
                    {expandedRows.has(idx) ? "▼ " : "▶ "}
                    {row.workstream + ' | '+ row.workstreamID}
                  </td>
                  <td>{row.phase}</td>
                  <td>{row.review_status}</td>
                </tr>

                {/* Child Table */}
                {expandedRows.has(idx) && (
                  <tr>
                    <td colSpan="4">
                      <table className="table table-sm table-bordered mt-2 assessmentDisplayTable">
                        <thead className="table-light">
                          <tr>
                            <th>Assessment Type</th>
                            <th>Maturity Level</th>
                            <th>Completed On</th>
                          </tr>
                        </thead>                        <tbody>
                          {Array.isArray(row.assessments) &&
                          row.assessments.length > 0 ? (
                            row.assessments.map((a, i) => (
                              <tr key={i}>
                                <td>{a.Type || "Not Reported"}</td>
                                <td>{a.maturity_level || "Not Reported"}</td>
                                <td>{a["Completion Date"] || "Not Reported"}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                No assessments available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
         <img src={sgrStatusImg} alt="status" className="sgr-status w-50 mt-2" />
        </>
      ) : (
        <p>
          No Assessment details available.
        </p>
      )}

      {/* Footer */}
      <div className="">
        <div>
          {sgrUrl ? (
                  <div className="d-flex justify-content-between align-items-center mt-2">
  <div>
    Data Source: <a target="_blank" href={sgrUrl}>SGR Dashboard</a> {lastDate && <span>on {lastDate}</span>}
  </div>
  <div>
  </div>
</div>
          ) : (
            <span className="text-muted">No Assessment details available</span>
          )}
        </div>
        {/* <div>
          Data as on :{" "}
          <span>
            {projectDemographicsWeb?.project_demographics?.last_sunday ||
              "NA"}
          </span>
        </div> */}
      </div>
    </>
  );
})()}

  </td>
</tr>
                  </tbody>
      </table>
      </div>
      {showFeedback && (<FeedbackWidget moduleName="project_demographics_web" onSubmit={() => setShowFeedback(false)}/>)}
      <div className="footerText">Content Generated by Gen AI, limiting accuracy in few cases. Please use at your own discretion.</div>
    </div>
    {loading && <Loader />} 
    </Container>    
    </div>
  );
};

function displayRagColour(value) {
  if (!value) return "NA";

  const ragMap = {
    "Green": "🟢",
    "Red": "🔴",
    "Amber": "🟡",
    "Grey": "🔘"
  };

  const items = value.split(",");
  let currentRag = null;
  const resultLines = [];

  // First pass: Find first explicit rag assignment
  for (const item of items) {
    if (item.includes(":")) {
      const [, rag] = item.split(":");
      currentRag = rag.trim();
      break;
    }
  }

  // Default rag if none provided
  if (!currentRag) currentRag = "Grey";

  // Second pass: Build final formatted output
  for (const item of items) {
    let label;
    if (item.includes(":")) {
      [label, currentRag] = item.split(":");
      currentRag = currentRag.trim();
    } else {
      label = item;
    }

    const emoji = ragMap[currentRag] || "🔘";
    resultLines.push(`- ${emoji} ${label.trim()}`);
  }

  return resultLines.join("\n\t");
}


function Project_GenAi_adaptive_text(a = {}) {
    // Helper: check missing / null / empty / NaN
    function isMissing(val) {
        if (val === null || val === undefined || val === "") return true;
        if (typeof val === "number" && isNaN(val)) return true;
        if (String(val).toLowerCase() === "nan") return true;
        return false;
    }

    let lines = [];
    const url = "https://atcidelivery.accenture.com/Central/special-focus/gen-aitracking/genAITrackingLanding";
    const genAIUrl = `[Click Here](${url})`;

    // Gen AI Status
    if (!isMissing(a["committed-RAG"])) {
        lines.push(`- Gen AI Status : \n\t ${displayRagColour(a["committed-RAG"])}`);
    }

    // 1. Committed | Scaled
    if (!isMissing(a["Committed | Scaled "])) {
        lines.push(`- Committed | Scaled : ${a["Committed | Scaled "]}`);
    }

    // 2. Summarize
    if (!isMissing(a["tms-genai-summary"])) {
        lines.push(`- Summarize the patterns: ${a["tms-genai-summary"]}.`);
    }

    // 2b. Patterns
    if (!isMissing(a["Patterns"])) {
        lines.push(`- Pattern: ${a["Patterns"]}.`);
    }
    if (!isMissing(a["Savings Reflection"])) {
        lines.push(`- Savings Reflection: ${a["Savings Reflection"]}.`);
    }
    if (!isMissing(a["GenAI Savings %"])) {
        lines.push(`- GenAI Savings %: ${a["GenAI Savings %"]}.`);
    }

    // 3. Committed Gen AI Effort Savings
    if (!isMissing(a["Committed Gen AI Effort Savings"])) {
        lines.push(`- Committed Gen AI Effort Savings %: ${a["Committed Gen AI Effort Savings"]}.`);
    }

    // 4. Actual GenAI Effort Savings
    if (!isMissing(a["Actual GenAI Effort Savings"])) {
        lines.push(`- Actual GenAI Effort Savings %: ${a["Actual GenAI Effort Savings"]}.`);
    }

    if (!isMissing(a["Planned GenAI Effort Savings"])) {
        lines.push(`- Planned GenAI Effort Savings %: ${a["Planned GenAI Effort Savings"]}.`);
    }

    // 5. Planned Gen AI Productivity ($)
    if (!isMissing(a["Planned Gen AI Productivity ($)"])) {
        lines.push(`- Planned Gen AI Productivity ($) : ${a["Planned Gen AI Productivity ($)"]}`);
    }

    // 6. Realized Gen AI Productivity ($)
    if (!isMissing(a["Realized Gen AI Productivity ($)"])) {
        lines.push(`- Realized Gen AI Productivity ($) : ${a["Realized Gen AI Productivity ($)"]}`);
    }

    // If no data → return empty string
    if (lines.length === 0) {
        return "NO Data Available";
    }

    // Build final text + click-here message
    let final_text = lines.join("\n");
    final_text += `\n\n${genAIUrl} for more details on the Gen AI status of this project`;
    console.log('final_text',final_text);
    return final_text;
}




export default Project;
